// removed by extract-text-webpack-plugin
module.exports = {"container":"InfoCarousel__container__31tcP","info":"InfoCarousel__info__1L-Kg","visible":"InfoCarousel__visible__3OqHo","swipeButton":"InfoCarousel__swipeButton__RcoCR","divider":"InfoCarousel__divider__3hjLC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexPage/InfoCarousel.scss
// module id = 684
// module chunks = 0